import { RoomItemPriceType } from '../types/rooms';
import { ReservationItem } from '../types/order';

export const compareReservation = (roomInOrder: ReservationItem, roomPrice: RoomItemPriceType, roomId) => {
    //console.log(roomInOrder.roomTypeId, roomId, roomInOrder.price.rateId, roomPrice.rateId);
    return roomInOrder.roomTypeId === roomId && roomInOrder.price.rateId === roomPrice.rateId
}
